// Lucide icon: folder-archive (https://lucide.dev/icons/folder-archive)
import { FolderArchive } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconFileZip = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <FolderArchive />
    </IconComponentStyled>
  )
}
